import DetailManifest from "./detail";

const routes = [
  {
    path: "/manifest/:id",
    component: DetailManifest,
  },
];

export default routes;
